import { useCmsClientContext } from './cmsPageContext';
import { getLinkType } from './getLinkType';
import { cmsQueryParamsPrefix } from './routing';
import { editLinkQuery } from './searchParams/urlHelpers';
import {
  isTiPurchaseFunnelPath,
  TRAVEL_SEARCH_URL_PARAM_KEYS,
} from './travelInsurance/tiFunnel';
import { useSafeSearchParams } from './useSafeSearchParams';

const forbiddenQueryParams = ['amount', 'tenure'];
export const useAppendQueryParams = () => {
  const searchParams = useSafeSearchParams();
  const { host } = useCmsClientContext();

  // CMS-1866: TI search params are forwarded only to TI purchase funnel
  // pages; links leading outside the funnel don't receive them. Computed once
  // per render — the funnel check runs per link only when TI params are
  // actually present in the current URL.
  const hasTravelParams =
    !!searchParams &&
    [...searchParams.keys()].some((key) =>
      TRAVEL_SEARCH_URL_PARAM_KEYS.has(key),
    );

  return (link: string): string => {
    const linkType = getLinkType(link, host);
    switch (linkType) {
      case 'external':
      case 'hash':
        // An anchor keeps the page's query anyway; one added would make it a
        // navigation.
        return link;
      case 'internal':
        return editLinkQuery(link, (linkSearchParams, baseLink) => {
          const keepTravelParams =
            !hasTravelParams || isTiPurchaseFunnelPath(baseLink);

          if (searchParams) {
            for (const key of searchParams.keys()) {
              const isNewCmsQuery = key.startsWith(cmsQueryParamsPrefix);
              const isForbiddenQuery = forbiddenQueryParams.includes(key);
              const isStrippedTravelParam =
                !keepTravelParams && TRAVEL_SEARCH_URL_PARAM_KEYS.has(key);
              if (isNewCmsQuery || isForbiddenQuery || isStrippedTravelParam) {
                continue;
              }
              linkSearchParams.set(key, searchParams.get(key)!);
            }
          }
        });
      default:
        linkType satisfies never;
        return link;
    }
  };
};
